import React from 'react';
import { StyleSheet, Text, TextStyle, View, ViewStyle } from 'react-native';

import { Fonts } from '../../../Common/services/utils/AppConstants';

type Props = {
  backgroundColor: string;
  color: string;
  studentGrade: string;
  textStyle?: TextStyle;
  viewStyle?: ViewStyle;
};

export const GradeDefault = (props: Props): React.ReactElement => {
  const { backgroundColor, color, studentGrade, viewStyle, textStyle } = props;

  return (
    <View style={[styles.circle, { backgroundColor }, viewStyle]}>
      <Text style={[styles.text, { color }, textStyle]}>{studentGrade}</Text>
    </View>
  );
};

const styles = StyleSheet.create({
  circle: {
    width: 50,
    height: 50,
    borderRadius: 25,
    justifyContent: 'center',
    alignItems: 'center',
  },
  text: {
    ...Fonts.largeBold,
  },
});
